import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import { useGlobalContext } from "context/global";

const Product = ({ product }) => (
	<Link to={`/products/${product?.handle}`} state={{ modal: true, title: product?.title }}
		className="flex mb-5 items-center gap-6">
		{product?.images && <Image className="w-1/5 md:w-[14%]" image={product?.images[0]?.asset} alt={product.info?.image?.alt} />}
		<div className="flex flex-col justify-center w-3/5">
			<div className="mb-2">{product?.title}</div>
			<div className="text-[#757575]">{product.inBundleDetails?.description}</div>
		</div>
	</Link>
);

const BundleProducts = ({ products, total }) => {
	const { translation } = useGlobalContext();

	return (
		<>
			<div className="flex justify-between mb-5 text-gray-500">
				<div className="uppercase text-small tracking-widest"> {translation.product.content} </div>
				<div className="uppercase text-small">
					{total} {translation.product?.products}
				</div>
			</div>
			{products.map((product, i) => <Product key={i} product={product} />)}
		</>
	);
};

export default BundleProducts;
